/* eslint-disable @typescript-eslint/no-explicit-any */
import type { PayloadPushNotificationProps } from 'modules/partial'
import type { DetailStateProps, ErrorProps } from 'modules/types'
import GLOBAL from 'modules/global'
import Notification from 'components/notification'
import { useCreatePushNotificationMutation } from 'store/pushNotification'
import PushNotificationForm from 'pages/pushNotification/list/form'

const Create = ({ open, onClose, resyncList }: DetailStateProps) => {
  if (!open) return <></>

  const [createPushNotification, create] = useCreatePushNotificationMutation()

  const initialValues: PayloadPushNotificationProps = {
    name: '',
    airingTime: '',
    memberTiers: [],
    headline: '',
    subHeadline: '',
    carModel: [],
    carModelYear: [],
    ctaUrl: '',
    image: null,
    imageUrl: null,
    targetOptions: [],
    salutation: '',
    vinCsvFile: null,
    memberIdCsvFile: null,
    vinCsvFileUrl: '',
    memberIdCsvFileUrl: '',
    locations: [],
    carOwnership: [],
    licensePlateType: '',
    activeStatus: '',
    bluelinkStatus: '',
    CarModelYears: [],
    handoverDateRange: { minDate: '', maxDate: '' }
  }

  const handleSubmit = (values: FormData) => {
    createPushNotification(values)
  }

  return (
    <>
      <PushNotificationForm
        title='Create New Push Notification'
        open={open}
        onCancel={onClose}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        loading={create.isLoading}
        submitText='Save as Draft'
      />
      <Notification
        open={!create.isLoading && !create.isUninitialized}
        onClose={() => {
          create.reset()
          if (create.isSuccess) {
            onClose()
            resyncList?.()
          }
        }}
        isError={Boolean(create.error) && create.isError}
        message={GLOBAL.returnExceptionMessage(create.isError, create.error as ErrorProps)}
      />
    </>
  )
}

export default Create
